import { useEffect, useState } from "react";
import axios from "axios";
import Reveal from "@/components/Reveal";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const defaults = [
  {
    src: "https://images.unsplash.com/photo-1438232992991-995b7058bbb3?q=80&w=1600&auto=format&fit=crop",
    alt: "Congregación adorando con manos levantadas en luz dramática",
    caption: "Adoración",
  },
  {
    src: "https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?q=80&w=1200&auto=format&fit=crop",
    alt: "Congregación celebrando con luces en la oscuridad",
    caption: "Celebración",
  },
  {
    src: "https://images.unsplash.com/photo-1453219562534-36e2ce0ea18e?q=80&w=1200&auto=format&fit=crop",
    alt: "Biblia abierta en luz cálida",
    caption: "Palabra",
  },
  {
    src: "https://images.unsplash.com/photo-1579975096649-e773152b04cb?q=80&w=1200&auto=format&fit=crop",
    alt: "Manos levantadas en la oscuridad",
    caption: "Espíritu",
  },
  {
    src: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?q=80&w=1200&auto=format&fit=crop",
    alt: "Grupo de estudio bíblico tomando notas",
    caption: "Estudio",
  },
];

const Galeria = () => {
  const [photos, setPhotos] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/gallery`)
      .then(({ data }) => setPhotos(data))
      .catch(() => setPhotos([]));
  }, []);

  const images = (() => {
    const source =
      photos && photos.length > 0
        ? photos.map((p) => ({ src: `${BACKEND_URL}${p.url}`, alt: p.caption || "Foto de la congregación", caption: p.caption || "" }))
        : defaults;
    const groups = {};
    source.forEach((img) => {
      (groups[img.caption] = groups[img.caption] || []).push(img);
    });
    const ordered = [];
    let added = true;
    while (added) {
      added = false;
      Object.values(groups).forEach((g) => {
        if (g.length) {
          ordered.push(g.shift());
          added = true;
        }
      });
    }
    return ordered;
  })();

  return (
    <section className="border-t border-white/10 bg-surface py-28 lg:py-36" data-testid="galeria-section">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <div className="mb-16 flex flex-wrap items-end justify-between gap-8">
          <Reveal>
            <p className="mb-8 flex items-center gap-4 text-[10px] font-light uppercase tracking-[0.5em] text-fire" data-testid="galeria-eyebrow">
              <span className="inline-block h-px w-16 bg-fire" /> Nuestra casa
            </p>
            <h2 className="font-serif text-5xl leading-[0.95] tracking-tight text-paper sm:text-7xl" data-testid="galeria-title">
              Momentos de <em className="italic text-gold">encuentro</em>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-sm font-light leading-relaxed tracking-wide text-smoke">
              Cada reunión es un momento donde el cielo toca la tierra. Esto es un poco de lo que vivimos juntos.
            </p>
          </Reveal>
        </div>

        <div className="grid gap-px border border-white/10 bg-white/10 lg:grid-cols-3">
          {images.map((img, i) => (
            <Reveal key={img.src} delay={Math.min(i, 3) * 0.1} className={i === 0 ? "bg-ink lg:col-span-2 lg:row-span-2" : "bg-ink"}>
              <figure className="group relative h-full overflow-hidden" data-testid={`galeria-img-${i}`}>
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  className="h-full min-h-[300px] w-full object-cover opacity-90 transition-all duration-[1.2s] ease-out group-hover:scale-105 group-hover:opacity-100"
                />
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Galeria;
